import React, { createContext, useContext, useState, useEffect } from 'react';

interface Permission {
    module: string;
    access: string;
}

const PermissionContext = createContext<Permission[] | null>(null);

interface PermissionProviderProps {
    children: React.ReactNode;
}

export const PermissionProvider: React.FC<PermissionProviderProps> = ({
    children,
}) => {
    const [permissions, setPermissions] = useState<Permission[] | null>(null);

    useEffect(() => {
        async function loadPermissions() {
            // Hardcoded API response (simulating backend data)
            const data = {
                user_id: 6557,
                roles: [{ role_id: 1, role_name: 'Admin' }],
                permissions: [
                    { module: 'Permits', access: 'Read' },
                    { module: 'Fines', access: 'Read' },
                    { module: 'Parkinglots', access: 'Hidden' },
                    { module: 'Users', access: 'Read' },
                    { module: 'TicketRules', access: 'Write' },
                ],
            };

            // Simulating API delay
            await new Promise((resolve) => setTimeout(resolve, 500));

            setPermissions(data.permissions);
        }

        loadPermissions();
    }, []);

    return (
        <PermissionContext.Provider value={permissions}>
            {children}
        </PermissionContext.Provider>
    );
};

// Hook to use permissions anywhere in the app
export const usePermissions = (): Permission[] | null => {
    return useContext(PermissionContext);
};
